import { render, staticRenderFns } from "./BenefitModalItemDetail.vue?vue&type=template&id=58b72786&"
import script from "./BenefitModalItemDetail.vue?vue&type=script&lang=js&"
export * from "./BenefitModalItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports